export default __webpack_public_path__ + "static/AX-logo-WB-W-profile-7bdd08abb17f9987c87777d469a156d9.jpg";